import wiki from "@/systems/modules/wiki/wiki.js";
import blog from "@/systems/modules/blog/blog.js";
import support from "@/systems/modules/support/support.js";
import punishments from "@/systems/modules/punishments/punishments.js";
import allowlist from "@/systems/modules/allowlist/allowlist.js";
import applications from "@/systems/modules/applications/applications.js";
import analytics from "@/systems/modules/analytics/analytics.js";
import CreateCommunityView from "@/systems/community/views/CreateCommunityView.vue";
import CommunityDetailsView from "@/systems/community/views/CommunityDetailsView.vue";
import {adminRoles} from "@/systems/main/adminRoles.js";
import automation from "@/systems/modules/automation/automation.js";
import roles from "@/systems/modules/roles/roles.js";
import settings from "@/systems/modules/settings/settings.js";
import {modules} from "@/systems/modules/modules.js";
import players from "@/systems/modules/players/players.js";
import {RouterView} from "vue-router";
import CommunityDashboardView from "@/systems/community/views/CommunityDashboardView.vue";
import authorization from "@/authorization";
import CommunityAdministrationHeaderView from "@/systems/community/views/CommunityAdministrationHeaderView.vue";
import CommunityUsersView from "@/systems/community/views/CommunityUsersView.vue";
import CommunityModulesView from "@/systems/community/views/CommunityModulesView.vue";
import auditLogs from "@/systems/modules/auditLogs/auditLogs";
import ServersView from "@/systems/community/views/ServersView.vue";

export default {
    initialize() {

    },
    getRoutes: () => ([
        {
            name: "communities",
            path: "/communities",
            component: RouterView,
            redirect: { name: "home" },
            children: [
                {
                    name: "communities.create",
                    path: "create",
                    component: CreateCommunityView
                },
                {
                    name: "community",
                    path: ":communityId",
                    props: true,
                    component: RouterView,
                    redirect: { name: "community.dashboard" },
                    children: [
                        {
                            path: "dashboard",
                            name: "community.dashboard",
                            component: CommunityDashboardView,
                            props: true
                        },
                        ...players.getRoutes(),
                        ...blog.getRoutes(),
                        ...wiki.getRoutes(),
                        ...support.getRoutes(),
                        ...punishments.getRoutes(),
                        ...allowlist.getRoutes(),
                        ...applications.getRoutes(),
                        ...analytics.getRoutes(),
                        ...automation.getRoutes(),
                        ...auditLogs.getRoutes(),
                        {
                            name: "community.administration",
                            path: "administration",
                            component: CommunityAdministrationHeaderView,
                            redirect: { name: "community.administration.details" },
                            children: [
                                {
                                    name: "community.administration.details",
                                    path: "details",
                                    component: CommunityDetailsView,
                                    props: true,
                                    meta: {
                                        authorize: () => authorization.communityAdministrator() || authorization.adminRole(adminRoles.moderator),
                                    }
                                },
                                ...roles.getRoutes(),
                                {
                                    name: "community.administration.users",
                                    path: "users",
                                    component: CommunityUsersView,
                                    props: true,
                                    meta: {
                                        authorize: () => authorization.communityAdministrator(),
                                    }
                                },
                                {
                                    name: "community.administration.modules",
                                    path: "modules",
                                    component: CommunityModulesView,
                                    props: true,
                                    meta: {
                                        authorize: () => authorization.permission("toggleModules")
                                    }
                                },
                                ...settings.getRoutes(modules.core),
                                {
                                    name: "community.administration.servers",
                                    path: "servers",
                                    component: ServersView,
                                    props: true,
                                    meta: {
                                        authorize: () => authorization.permission("community.manageServers")
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        },
    ])
};